import { AdminTicketService } from './../../services/admin-ticket.service'
import { ClientTicketService } from './../../services/client-ticket.service'
import { Creators as SiteCreators } from '../site/site'
import { createActions, createReducer } from 'reduxsauce'

const initialState = {
	tickets: [],
	isLoading: false,
	isModalOpen: false,
	fetchTimestamp: '',
	pixData: {
		pixImageQrCode: '',
		pixValidity: null,
		pixEmv: '',
		provider: '',
	},
	isQRCodeModalOpen: false,
	promotionCouponCode: Object,
}

const setFetchingData = (state = initialState, { fetchTimestamp }) => ({
	...state,
	fetchTimestamp,
})

const setData = (
	state = initialState,
	{ data, orderNumber, fetchTimestamp }
) => {
	const isSameRequest = state.fetchTimestamp == fetchTimestamp
	return {
		...state,
		orderNumber,
		isLoading: !isSameRequest,
		tickets: isSameRequest ? data.tickets : state.tickets,
		promotionCoupon: isSameRequest
			? data.promotionCouponCode
			: state.promotionCouponCode,
	}
}

const fetchData = (orderNumber) => (dispatch) => {
	const timestamp = +new Date()
	dispatch(Creators.setFetchingData(timestamp))
	dispatch(SiteCreators.showLoading())
	return ClientTicketService.getTickets(orderNumber).then((data) => {
		dispatch(Creators.setData(data, orderNumber, timestamp))
		dispatch(SiteCreators.hideLoading())
	})
}

const fetchDataAsAdmin = (orderNumber) => (dispatch) => {
	const timestamp = +new Date()
	dispatch(Creators.setFetchingData(timestamp))
	dispatch(SiteCreators.showLoading())
	return AdminTicketService.getTickets(orderNumber).then((data) => {
		dispatch(Creators.setData(data, orderNumber, timestamp))
		dispatch(SiteCreators.hideLoading())
	})
}

const removeTicket = (state = initialState, { trackNumber, ticketNumber }) => ({
	...state,
	tickets: state.tickets.map((item) => {
		if (
			item.trackNumber == trackNumber &&
			item.ticketNumber == ticketNumber
		) {
			item.canReturn = false
		}
		return item
	}),
})

const removeAllTickets = (
	state = initialState,
	{ trackNumber, ticketNumber, isGoing }
) => {
	const ticket = state.tickets.find(
		(o) => o.trackNumber == trackNumber && o.ticketNumber == ticketNumber
	)
	return {
		...state,
		tickets: state.tickets.map((item) => {
			if (item.departure == ticket.departure) item.canReturn = false
			return item
		}),
	}
}

const returnTicket = (ticketNumber, trackNumber, cancelAll, isGoing) => (
	dispatch
) => {
	dispatch(SiteCreators.showLoading())
	return ClientTicketService.returnTicket({
		ticketNumber,
		trackNumber,
		cancelAll,
		isGoing,
	}).then(({ data, success, errors }) => {
		dispatch(SiteCreators.hideLoading())
		if (success) {
			if (cancelAll) {
				dispatch(
					Creators.removeAllTickets(ticketNumber, trackNumber, isGoing)
				)
			} else {
				dispatch(Creators.removeTicket(ticketNumber, trackNumber))
			}
		}
		return { data, success, errors }
	})
}

const returnTicketAsAdmin = (ticketNumber, trackNumber, cancelAll, isGoing) => (
	dispatch
) => {
	dispatch(SiteCreators.showLoading())
	return AdminTicketService.returnTicket({
		ticketNumber,
		trackNumber,
		cancelAll,
		isGoing,
	}).then(({ data, success, errors }) => {
		dispatch(SiteCreators.hideLoading())
		if (success) {
			if (cancelAll) {
				dispatch(
					Creators.removeAllTickets(ticketNumber, trackNumber, isGoing)
				)
			} else {
				dispatch(Creators.removeTicket(ticketNumber, trackNumber))
			}
		}

		return { data, success, errors }
	})
}

const openQrCodeModal = (state = initialState, { pixData }) => ({
	...state,
	isQRCodeModalOpen: true,
	pixData: pixData,
})

export const { Types, Creators } = createActions(
	{
		fetchData,
		returnTicket,
		openModal: null,
		closeModal: null,
		fetchDataAsAdmin,
		returnTicketAsAdmin,
		openQrCodeModal: ['pixData'],
		removeAllTickets: ['ticketNumber', 'trackNumber', 'isGoing'],
		setData: ['data', 'orderNumber', 'fetchTimestamp'],
		setFetchingData: ['fetchTimestamp'],
		removeTicket: ['ticketNumber', 'trackNumber'],
	},
	{
		prefix: 'client-ticket-modal/',
	}
)

const openModal = (state = initialState) => ({ ...state, isModalOpen: true })
const closeModal = (state = initialState) => ({
	...state,
	isModalOpen: false,
	isQRCodeModalOpen: false,
})

export default createReducer(initialState, {
	[Types.SET_DATA]: setData,
	[Types.OPEN_MODAL]: openModal,
	[Types.CLOSE_MODAL]: closeModal,
	[Types.REMOVE_TICKET]: removeTicket,
	[Types.SET_FETCHING_DATA]: setFetchingData,
	[Types.OPEN_QR_CODE_MODAL]: openQrCodeModal,
	[Types.REMOVE_ALL_TICKETS]: removeAllTickets,
})
